import { useMemo } from 'react'

/** Clients of the booking as a list; there is always at least one, possibly without services */
export const useClientsList = <T>(clients: Record<number, T[]>): T[][] => useMemo(() => {
  const list = Object.values(clients)
  return list.length ? list : [[]]
}, [clients])
